import styled from 'styled-components';

export const Container = styled.div`
  background-color: #f0f1f2;

  small {
    border: 1px solid #9e9e9e;
    border-radius: 5px;
    padding: 2px 10px;
    display: block;
    background-color: #fbfdff;
    font-style: italic;
    border-style: dashed;
  }

  button {
    color: #28c893;
  }

  .card-text {
    font-size: 17px;
  }

  label {
    font-size: 15px;
  }

  .btn-submit {
    background-color: #28c893;
    color: #fff;
    border: 1px solid #28c893;
  }

  @media screen and (max-width: 768px) {
    .card {
      margin-bottom: 100px !important;
    }
  }
`;
